import React from 'react';

var MobileUserBalanceAndTotalBet = function (_a) {
    var label = _a.label, value = _a.value, currency = _a.currency;
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { className: 'pgc-m-footer-txt' }, label),
        React.createElement("p", { className: 'pgc-m-footer-num' },
            value,
            " ",
            React.createElement("span", { className: 'pgc-m-footer-num-txt' }, currency))));
};

export { MobileUserBalanceAndTotalBet };
